import $ from "jquery";
import { dataaccess } from "../dataaccess/dataContext";
import { dateFormatter } from "../framework/dateFormatter";
import { forms } from "../framework/forms";

function init() {
    $("#NotAcceptDateTime").prop("disabled", !$("#NotAcceptCommercialSupport").prop("checked"));
    $("#InformationChangedDateTime").prop("disabled", !$("#InformationChanged").prop("checked"));
    $("#DisclosureSignatureSection input").prop("disabled", !$("#AcceptDisclosure").prop("checked"));
    const currentYear = new Date().getFullYear();
    $("#SpanCurrentYear").text(currentYear);

    setEvents();
}

function setEvents() {
    $(".js-view-form").click(function() {
        const disclosureId = $(this).data("id");
        const personId = $(this).attr("personId");
        $("#PersonId").val(personId);

        dataaccess
            .get({ url: `/DisclosureForm/View/${disclosureId}` })
            .done(function(htmlResult) {
                $("#AddDisclosureModal .modal-content").html(htmlResult);
                const $form = $("#AddDisclosureForm");
                $form.find("button, input, textarea").prop("disabled", true);
                $form.find(".datepicker").removeClass("datepicker");
                $("#AddNewRelationship")
                    .closest("tr")
                    .hide();
                dateFormatter.initDatePicker();
            });
    });

    $("#AddDisclosureBtn").click(function() {
        const personId = $(this).attr("personId");
        dataaccess
            .get({ url: `/DisclosureForm/Add?personId=${personId}` })
            .done(function(htmlResult) {
                $("#AddDisclosureModal .modal-content").html(htmlResult);
                const $form = $("#AddDisclosureForm");
                $.validator.unobtrusive.parse($form);
                dateFormatter.initDatePicker();
                const currentDate = new Date();
                $("#ActivityName").val("Standardized Trauma Programs – " + currentDate.getUTCFullYear());
                $("#PersonId").val(personId);
                $("#ReturnToControllerName").val($("#ReturnToControllerName2").val());
            });
    });

    $(document).on("change", "#NoCommercialInterest", function() {
        if (this.checked) {
            $("#CommercialInterest").prop("checked", false);
            $("#HdnCommercialInterestCount").val("1");
            $("[id^=CommercialInterest]")
                .removeAttr("required")
                .val("");
            $("#CommercialInterestTable tbody tr:not(:first)").remove();
            $("#CommercialInterestValidation, #CommercialInterestTable").hide();

            $("#NotAcceptCommercialSupport").attr("required", "required");
            $("#NotAcceptDateTime")
                .attr("required", "required")
                .prop("disabled", false);

            $("#InformationChanged").attr("required", "required");
            $("#InformationChangedDateTime")
                .attr("required", "required")
                .prop("disabled", false);

            $("#AcceptDisclosure").attr("required", "required");
            $("#DisclosureSignatureSection input")
                .attr("required", "required")
                .prop("disabled", false);
        } else {
            $(this).prop("checked", true);
        }
    });

    $(document).on("change", "#CommercialInterest", function() {
        if (this.checked) {
            $("#NoCommercialInterest").prop("checked", false);
            $("[id^=CommercialInterest]").attr("required", "required");
            $("#CommercialInterestValidation").hide();
            $("#CommercialInterestTable").show();

            $("#NotAcceptCommercialSupport").removeAttr("required");
            $("#InformationChanged").removeAttr("required");

            $("#NotAcceptDateTime").removeAttr("required");
            $("#NotAcceptDateTime-error").hide();
            $("#InformationChangedDateTime").removeAttr("required");
            $("#InformationChangedDateTime-error").hide();
            $("#DisclosureSignatureSection input").removeAttr("required");
            $("#AcceptDisclosureName-error").hide();
            if ($("#NotAcceptCommercialSupport").is(":checked") &&
                $("#NotAcceptDateTime").val() === "")
                $("#NotAcceptCommercialSupport").prop("checked", false);
            if ($("#InformationChanged").is(":checked") &&
                $("#InformationChangedDateTime").val() === "")
                $("#InformationChanged").prop("checked", false);
            if ($("#AcceptDisclosure").is(":checked") && $("#DisclosureSignatureSection input").val() === "")
                $("#AcceptDisclosure").prop("checked", false);
        } else {
            $(this).prop("checked", true);
        }
    });

    $(document).on("change", "#NotAcceptCommercialSupport", function() {
        $(this).is(":checked")
            ? $("#NotAcceptDateTime")
                .attr("required", "required")
                .prop("disabled", false)
            : $("#NotAcceptDateTime")
                .removeAttr("required")
                .prop("disabled", true)
                .val("");
    });

    $(document).on("change", "#InformationChanged", function() {
        $(this).is(":checked")
            ? $("#InformationChangedDateTime")
                .attr("required", "required")
                .prop("disabled", false)
            : $("#InformationChangedDateTime")
                .removeAttr("required")
                .prop("disabled", true)
                .val("");
    });

    $(document).on("change", "#AcceptDisclosure", function() {
        $(this).is(":checked")
            ? $("#DisclosureSignatureSection input")
                .attr("required", "required")
                .prop("disabled", false)
            : $("#DisclosureSignatureSection input")
                .removeAttr("required")
                .prop("disabled", true)
                .val("");
    });

    $(document).on("click", "#AddNewRelationship", function() {
        const rowcount = $("#HdnCommercialInterestCount").val();
        if (!validateCommercialInterest(parseInt(rowcount) - 1)) {
            alert("Complete the current row information before adding a new one");
            return;
        }

        const html = `<tr>
            <td>
                <div class="row border-bottom">
                    <div class="col-lg-4">
                        <label for="CommercialInterests_${rowcount}__CommercialInterestName">Commercial Interest</label>
                    </div>
                    <div class="col-lg-8">
                        <textarea id="CommercialInterests_${rowcount}__CommercialInterestName" name="CommercialInterests[${rowcount}].CommercialInterestName" class="form-control commercialInterest" cols="60" rows="2" maxlength="255" required></textarea>
                        <span data-valmsg-for="CommercialInterests[${rowcount}].CommercialInterestName" class="text-danger field-validation-valid" data-valmsg-replace="true"></span>
                  </div>
                </div>
                <div class="row border-bottom">
                    <div class="col-lg-4">
                        <label for="CommercialInterests_${rowcount}__InterestPersonReceived">What I/Spouse/Partner Received</label>
                    </div>
                    <div class="col-lg-8">
                        <textarea id="CommercialInterests_${rowcount}__InterestPersonReceived" name="CommercialInterests[${rowcount}].InterestPersonReceived" class="form-control commercialInterest" cols="60" rows="2" maxlength="255" required></textarea>
                        <span data-valmsg-for="CommercialInterests[${rowcount}].InterestPersonReceived" class="text-danger field-validation-valid" data-valmsg-replace="true"></span>
                    </div>
                </div>
                <div class="row border-bottom">
                    <div class="col-lg-4">
                        <label for="CommercialInterests_${rowcount}__InterestPersonRole">For What Role?</label>
                    </div>
                    <div class="col-lg-8">
                        <textarea id="CommercialInterests_${rowcount}__InterestPersonRole" name="CommercialInterests[${rowcount}].InterestPersonRole" class="form-control commercialInterest" cols="60" rows="4" maxlength="255" required></textarea>
                        <span data-valmsg-for="CommercialInterests[${rowcount}].InterestPersonRole" class="text-danger field-validation-valid" data-valmsg-replace="true"></span>
                    </div>
                </div>
            </td>
        </tr>`;
        $("#CommercialInterestTable tbody").append(html);
        $("#HdnCommercialInterestCount").val(parseInt(rowcount) + 1);
    });

    $(document).on("click", "#DisclosureFormSubmitBtn", function() {
        const $form = $(this).closest("form");
        let isValid = $form.valid();

        if (!$("#CommercialInterest").prop("checked") && !$("#NoCommercialInterest").prop("checked") && !$("#StockHolderOfIneligibleCompany").prop("checked") && !$("#OwnerOfIneligibleCompany").prop("checked")) {
            $("#CommercialInterestValidation").show();
            isValid = false;
        }

        if (isValid) {
            forms.disableSubmitButton();
            $form.submit();
        }
    });

    $("#AddDisclosureModal").on("hidden.bs.modal", function(e) {
        $(this)
            .find("form")[0]
            .reset();
        $(".field-validation-valid").html("");
        $("#CommercialInterestTable").hide();
        $("#CommercialInterestTable tbody tr:not(:first)").remove();
    });
}

function validateCommercialInterest(rowNumber) {
    if ($("#CommercialInterests_" + rowNumber + "__CommercialInterestName").val() === "" ||
        $("#CommercialInterests_" + rowNumber + "__InterestPersonReceived").val() === "" ||
        $("#CommercialInterests_" + rowNumber + "__InterestPersonRole").val() === "") {
        return false;
    }
    return true;
}

export const addDisclosureForm = {
    init: init
};
